import type { FC } from "react"
import React, { useState } from "react"

import { useSetRecoilState } from "recoil"
import styled from "styled-components"

import { ReactComponent as PlusIcon } from "@svg/plus.svg"
import { ReactComponent as XIcon } from "@svg/x.svg"

import { showDesignSwitcherState } from "."
import { DesignRevisionDrawerOpenState } from "../Drawer/DesignRevision"

export const StyledHeader = styled.div`
  width: 100%;
  height: 75px;
  box-shadow: 0px 4px 5px rgba(53, 67, 95, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  > div {
    display: flex;
    align-items: center;
    height: 100%;
    gap: var(--space-m);
    > p {
      text-transform: capitalize;
      font-weight: 600;
      color: var(--blue-dark-font);
      font-size: var(--step--1);
    }
    > button {
      display: flex;
      align-items: center;
      cursor: pointer;
      svg {
        width: 25px;
        height: 25px;
      }
    }
  }
  > button {
    background-color: var(--blue);
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
    svg {
      width: 50%;
      height: 50%;
    }
  }
  > button:disabled {
    background-color: var(--blue-faded);
    cursor: not-allowed;
  }
`

export const Header: FC<{ resetDesign: () => void; disabled?: boolean }> = ({
  resetDesign,
  disabled,
}) => {
  const setShow = useSetRecoilState(showDesignSwitcherState)
  const setDesignRevision = useSetRecoilState(DesignRevisionDrawerOpenState)

  return (
    <StyledHeader>
      <div>
        <button onClick={() => (resetDesign(), setShow(false))}>
          <XIcon />
        </button>
        <p>Versions</p>
      </div>
      <button
        onClick={() => (setDesignRevision(true), setShow(false))}
        disabled={disabled}
      >
        <PlusIcon />
      </button>
    </StyledHeader>
  )
}
